import { AccountService } from './../../../services/account.service';
import { NotificationCountersService } from './../../../services/notification-counters.service';
import { WatchAccountService } from './../../../services/watch-account.service';
import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { PusherService } from '../../../services/pusher.service';
import { NotificationService } from '../../../services/notification.service';
import { GlobalWindow } from '../../../main.window';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { ModalNotificationComponent } from '../../modals/notification/modal-notification.component';
import { EventEmitter } from '@angular/core';
import { combineLatest } from 'rxjs';
import { SubscriptionNotificationService } from '../../../services/subscription-notification.service';

declare let window: GlobalWindow;

@Component({
  selector: 'account-layout',
  template: require('./account-layout.component.pug'),
  styles: [require('./account-layout.component.css').toString()],
  // encapsulation: ViewEncapsulation.None,
  // changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AccountLayoutComponent implements OnInit {
  routesub: any = null;

  sub: any = null;
  online: boolean = true;
  notificationModalRef: BsModalRef;

  interval: any;
  index = 0;
  accsub: any = null;

  planSub: any = null;
  plan = 'trial';

  // -------------------------------------------------------------------
  // -------------------------------------------------------------------
  // -------------------------------------------------------------------
  constructor(
    private route: ActivatedRoute,
    private watch: WatchAccountService,
    private pusherService: PusherService,
    private accountService: AccountService,
    private modalService: BsModalService,
    private notificationService: NotificationService,
    private notificationCountersService: NotificationCountersService,
    private subscriptionNotificationService: SubscriptionNotificationService,
    private cdr: ChangeDetectorRef,
  ) {
    this.sub = notificationService.networkStatus().subscribe(status => {
      this.online = status;
    });
  }

  // -------------------------------------------------------------------
  ngOnInit() {
    let account_id: string = null;

    this.handleAlert();
    this.handleNotice();

    this.routesub = this.route.paramMap.subscribe(params => {
      let new_account_id = params.get('account_id');

      if (new_account_id != account_id) {
        account_id = new_account_id;
        this.watch.accountId().next(account_id);
        this.pusherService.listenAccount(account_id);
        this.notificationCountersService.refresh(account_id);

        this.accsub = this.accountService
          .getAccountInfo(account_id)
          .subscribe(response => {
            this.planSub = this.subscriptionNotificationService.planName.subscribe(
              plan => {
                this.plan = plan;
                // this.cdr.detectChanges();
              },
            );
            // this.cdr.detectChanges();
            if (response.plan) {
              this.subscriptionNotificationService.planName.next(response.plan);
            }
          });
      }
    });

    this.index = 2;
  }

  // -------------------------------------------------------------------
  ngOnDestroy(): void {
    if (this.accsub) {
      this.accsub.unsubscribe();
    }
    if (this.sub) {
      this.sub.unsubscribe();
    }
    if (this.routesub) {
      this.routesub.unsubscribe();
    }
    if (this.planSub) {
      this.planSub.unsubscribe();
    }
  }

  // -------------------------------------------------------------------
  handleAlert() {
    const alert = window['quickmailAlert'] as string;
    if (!alert) return;

    this.handleNotificationModal('Alert', alert).subscribe(() => {
      window['quickmailAlert'] = undefined;
    });
  }

  // -------------------------------------------------------------------
  handleNotice() {
    const notice = window['quickmailNotice'] as string;
    if (!notice) return;

    this.handleNotificationModal('Notice', notice).subscribe(() => {
      window['quickmailNotice'] = undefined;
    });
  }

  // -------------------------------------------------------------------
  handleNotificationModal(title: string, content: string) {
    this.notificationModalRef = this.modalService.show(
      ModalNotificationComponent,
      {
        initialState: { content, title },
      },
    );

    return combineLatest(
      this.modalService.onHide,
      this.notificationModalRef.content.onClose as EventEmitter<void>,
    );
  }

  // -------------------------------------------------------------------
  envClass() {
    let newClass = {};

    switch (this.plan) {
      case 'basic':
        newClass['basic'] = true;
        break;
      case 'pro':
        newClass['pro'] = true;
        break;
      case 'expert':
        newClass['expert'] = true;
        break;
      case 'sleep':
        newClass['sleep'] = true;
        break;
      case 'expired':
        newClass['expired'] = true;
        break;
      default:
        newClass['trial'] = true;
    }

    return newClass;
  }
}
